// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function dateReviver(key: string, value: any): any {
    if (key === 'createdAt' || key === 'updatedAt' || key === 'date') {
        return new Date(value);
    }
    return value;
}
